import { NgModule } from '@angular/core';
import { ErcApplicationSmartComponent } from 'ng2-app/erc-application/erc-application-smart/erc-application-smart.component';
import { ProgressChecklistComponent } from 'ng2-app/components/progress-checklist/progress-checklist.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PercentageModule } from 'app/pipes/percentage/percentage-pipe.module';
import { BorrowerValuesListSmartModule } from 'ng2-app/components/borrower-values-list-smart/borrower-values-list-smart.module';
import { ErcCustomValuesSmartComponent } from './erc-custom-values/erc-custom-smart-values/erc-custom-values-smart.component';
import { ErcCustomValuesDisplayComponent } from './erc-custom-values/erc-custom-values-display/erc-custom-values-display.component';
import { FormlyCoreModule } from 'app/form-core/formly/formly-core.module';

@NgModule({
  declarations: [
      ErcApplicationSmartComponent,
      ProgressChecklistComponent,
      ErcCustomValuesSmartComponent,
      ErcCustomValuesDisplayComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    PercentageModule,
    MatProgressSpinnerModule,
    BorrowerValuesListSmartModule,
    FormlyCoreModule
  ],
  exports: [
    ErcApplicationSmartComponent,
  ]
})

export class ErcApplicationModule {}
